import {NgModule} from '@angular/core';
import {Route, RouterModule} from '@angular/router';
import {AppShellComponent} from './app-shell/app-shell.component';
import {ProductsRouteComponent} from './products-route/products-route.component';
import {UserLoggedInRouterGuard} from './user-logged-in.guard';
import {LoginRouteComponent} from './app-shell/login-route/login-route.component';
import {InsuranceFamilyResolver} from './service/insurance-family.resolver';
import {ProductFamilyRouteComponent} from './products-route/product-family-route/product-family-route.component';
import {PensionProductsFamilyRouteComponent} from './products-route/pension-products-family-route/pension-products-family-route.component';
import {FileNotFoundComponent} from './app-shell/file-not-found/file-not-found.component';
import {PackageSignedRouteComponent} from './app-shell/package-signed-route/package-signed-route.component';
import {MandateRouteComponent} from './mandate-route/mandate-route.component';

const routes: Route[] = [
  {
    path: '',
    component: AppShellComponent,
    runGuardsAndResolvers: 'always',
    children: [
      // NO default path: handled in app shell
      // do NOT navigate to '/' from this app: the app shell redirect is cancelled then
      // DO NOT FORGET to update app shell (AppShellComponent.isRouteProtected) when adding unprotected route
      {
        path: '',
        component: LoginRouteComponent,
      },
      {
        path: 'login',
        component: LoginRouteComponent,
      },
      {
        path: 'filenotfound',
        component: FileNotFoundComponent,
      },
      {
        path: 'packagesigned',
        component: PackageSignedRouteComponent,
      },
      {
        path: 'products',
        canActivate: [UserLoggedInRouterGuard],
        runGuardsAndResolvers: 'always',
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: ProductsRouteComponent,
          },
          {
            path: 'pensionstatus',
            component: PensionProductsFamilyRouteComponent,
          },
          {
            path: ':family',
            component: ProductFamilyRouteComponent,
            resolve: {
              insuranceCategoryFamily: InsuranceFamilyResolver,
            },
          },
        ],
      },
      {
        path: 'mandate',
        canActivate: [UserLoggedInRouterGuard],
        runGuardsAndResolvers: 'always',
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: MandateRouteComponent,
          },
        ],
      },

      // No fallback - handled in app shell, otherwise we loose query params

      {
        path: '**',
        redirectTo: '/',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    enableTracing: false,
    onSameUrlNavigation: 'reload',
    relativeLinkResolution: 'legacy',
  }),
  ],
  providers: [],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
